export default {
  Componentontheleft: {
    a1: '已出帐',
    a2: '未出账',
    a3: '历史账单'
  },
  heard: {
    search: '请输入供应商查询',
    wholeO: '全选'
  },
  table: {
    purchaseUnitName: '采购中心',
    purchaseUnitNo: '采购中心',
    looktotal: '查看合计',
    costDate: '费用产生时间',
    purchaseNo: '采购单号',
    discrepantdata: '差异数据',
    xiangqingData: '详情数据',
    pucsscxx: '采购单项次',
    goodsNo: '料号',
    goodsName: '品名',
    batchPurQty: '采购数量',
    sourceSeq: '来源项次',
    asnNo: '送货单号',
    asnSeq: '送货单项次',
    deliveryQty: '送货数量',
    receiveQty: '收货数量',
    checkReturnQty: '验退数量',
    inStoreQty: '入库/仓退数量',
    chacuo: '差错类别',
    minPurTaxPrice: '最小采购含税单价',
    purTaxAmount: '采购含税金额',
    PurTaxPrice: '采购单价(未税)',
    purNoTaxAmount: '采购未税金额',
    unInvoiceQty: '可开票/对账数量',
    // =====
    minStoreUnTaxPrice: '入库未税单价',
    storeNoTaxAmount: '入库未税金额',
    minStoreTaxPrice: '入库含税单价',
    storeTaxAmount: '入库含税金额',
    // =====
    supplierName: '供应商',
    duizhang: '对账状态',
    kaipiao: '开票状态',
    opction: '操作',
    lookinfo: '查看详情',
    OK: '确认',
    NOOK: '取消确认',
    yikaipiao: '已开票',
    weikaipiao: '未开票',
    pucssyes: '采购商已确认',
    supyes: '供应商已确认',
    myheNo: '双方未确认',
    myheyes: '双方已确认',
    normality: '正常数据',
    abnormal: '异常数据',
    all: '全部',
    noaffirm: '未确认',
    yesaffirm: '已确认',
    palce: '请输入订单单号查询',
    pucsszhongx: '采购中心',
    sourceNo: '来源单据',
    goData: '开始日期',
    endData: '结束日期',
    keyword: '订单号',
    datadifference: ['正常数据', '异常数据'],
    cuttabs: ['明细', '总览'],
    invoiceSign: '仅查看未开票数据',
    import: '导出对账单',
    manual: '批量确认',
    yesnoOk: '是否进行操作',
    yesnoNOOk: '是否取消确认',
    diffSign: '仅显示差异数据',
    dayin: '对账明细信息',
    fafangbtn: '是否发放'
  },
  costdetail: {
    costDate: '费用类型',
    sourceNo: '来源单号',
    sourceSeq: '来源单项次',
    costType: '费用类型',
    supplierName: '供应商',
    feiyongDate: '费用时间',
    goodsName: '品名',
    goodsNo: '料号',
    diffAmount: '税额',
    taxAmount: '对账金额(含税)',
    invoiceQty: '对账数量(入库/退货)',
    unInvoiceQty: '剩余未开数量',
    purchaseNo: '订单号'
  },
  addfapiao: {
    searchPlaceholder: '订单号/来源单号',
    supplierName: '供应商名称',
    purchaseNo: '订单单号',
    goodsName: '料号',
    dateRange: '费用时间',
    addBtn: '生成待录入发票'
  },
  text: { // 别的页面用的，不要用这个
    lookokdata: '查看已确认未抛转数据',
    placeholdertext: '请输入发票号查询',
    billNo: '单据编号',
    invoiceNo: '单据编号',
    adddate: '开票时间',
    supOfficeNo: '供应商编号',
    lookbohuiinfo: '查看驳回原因',
    luru: '录入',
    chongxluru: '重新录入',
    supOfficeName: '供应商名称',
    allTaxAmount: '税额',
    status: '发票状态',
    userName: '发起人',
    throwStatus: '抛转状态',
    invoiceStartDate: '开票开始时间',
    invoiceEndDate: '开票结束时间',
    costType: '费用类型',
    purchaseNo: '订单单号',
    asnNo: '送货单号',
    goodsNo: '料件编号',
    sourceNo: '入库单号',
    status1: '待录入',
    status2: '待对票',
    status3: '已确认',
    status4: '已驳回',
    status5: '已作废',
    caozuo: '操作'
  }
}
